import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { DashboardService } from '../dashboard/dashboard.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ErrorStateMatcher} from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	  const isSubmitted = form && form.submitted;
	  return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}


@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {

  public loading = false;
  public saveError = false;
  public saveSuccess = false;
  public formError = false;
  public loadingPage = true;
  public addressForm;
  public address;
  public countrys = ["Canada", "United States", "France"];
  public provincesCanada = ["Alberta ","British Columbia","Manitoba","New Brunswick","Newfoundland and Labrador","Nova Scotia","Ontario","Prince Edward Island","Quebec","Saskatchewan","Northwest Territories","Nunavut","Yukon"];
  public provincesUsa = ['Alabama','Alaska','American Samoa','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Federated States of Micronesia','Florida','Georgia','Guam','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Marshall Islands','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Northern Mariana Islands','Ohio','Oklahoma','Oregon','Palau','Pennsylvania','Puerto Rico','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virgin Island','Virginia','Washington','West Virginia','Wisconsin','Wyoming'];
  public provincesFrance = ['Auvergne-Rhône-Alpes','Bourgogne-Franche-Comté','Bretagne','Centre-Val de Loire','Corse','Grand Est','Hauts-de-France','Île-de-France','Normandie','Nouvelle-Aquitaine','Occitanie','Pays de la Loire','Provence-Alpes-Côte d\'Azur','Guadeloupe','Martinique','Guyane','La Réunion','Mayotte'];
  public provincesDisplayed = this.provincesCanada;
  @Output() saved = new EventEmitter<boolean>();

  constructor(private formBuilder: FormBuilder, private dashboardService : DashboardService, public _snackBar: MatSnackBar) { }
  
  public matcher = new MyErrorStateMatcher();
  public get form() { return this.addressForm.controls; }
  

  ngOnInit(): void {
    this.addressForm = this.formBuilder.group({
      firstname: ['', [Validators.required, Validators.minLength(2),Validators.maxLength(50) ]] ,
      lastname: ['', [Validators.required, Validators.minLength(2),Validators.maxLength(50)]],
      address: ['', [Validators.required, Validators.minLength(8),Validators.maxLength(255)]],
      city: ['', [Validators.required, Validators.minLength(2),Validators.maxLength(50)]],
      province: ['', [Validators.required, Validators.minLength(3)]],
      postalcode: ['', [Validators.required, Validators.minLength(3),Validators.maxLength(10)]],
      country: ['', [Validators.required, Validators.minLength(3)]]
    });

    this.dashboardService.getAddress()
                            .subscribe(address => {
                              this.displayAddress(address)
                            },
                            err => {},
                            () =>  {this.loadingPage = false;});

    this.onChanges();
  }

  displayAddress(infoAddress){
    if(infoAddress===null)
      return;

    this.form['firstname'].setValue(infoAddress.firstname);
    this.form['lastname'].setValue(infoAddress.lastname);
    this.form['address'].setValue(infoAddress.address);
    this.form['city'].setValue(infoAddress.city);
    this.form['postalcode'].setValue(infoAddress.postalcode);

    var indexCountry = this.countrys.indexOf(infoAddress.country);
    var countryUser = this.countrys[indexCountry]
    this.form['country'].setValue(countryUser);

    this.setProvince(infoAddress.country, infoAddress.province);

  }

  setProvince(country, province = null){
    switch(country){
      case "Canada":
        this.provincesDisplayed = this.provincesCanada;
        this.form['province'].setValue(this.provincesCanada[this.provincesCanada.indexOf(province)]);
        break;
      case "United States":
        this.provincesDisplayed = this.provincesUsa;
        this.form['province'].setValue(this.provincesUsa[this.provincesUsa.indexOf(province)]);
        break;
      case "France":
        this.provincesDisplayed = this.provincesFrance;
        this.form['province'].setValue(this.provincesFrance[this.provincesFrance.indexOf(province)]);
        break;   
    }
  }


  onChanges(): void {
    var that = this; 

    this.addressForm.get('country').valueChanges.subscribe(country => {
      this.setProvince(country);
    });

    this.addressForm.valueChanges.subscribe(change => {
      this.saveError = false;
      this.saveSuccess = false;
      this.formError = false;
    });
  }

  async saveAddress(){
    let that = this;
    this.loading = true;
    if (this.addressForm.invalid) {
      this.loading = false;
      this.formError = true;
			return;
    }

    await this.dashboardService.updateAddress(this.form.firstname.value, 
                                        this.form.lastname.value, 
                                        this.form.address.value,
                                        this.form.city.value,
                                        this.form.province.value,
                                        this.form.postalcode.value,
                                        this.form.country.value)
                            .subscribe(res => {
                              this.address = res;
                            },
                            err => {
                              that._snackBar.open('An error occured please try again', 'Close', {
                                duration: 3000
                                });
                                that.saveError = true;
                                that.loading = false;
                            },
                            () =>  {
                              this.loading = false;
                              that._snackBar.open('Your address has been saved', 'Close', {
                                duration: 3000
                                });
                                this.saved.emit(this.address);
                                that.saveSuccess = true;
                                that.loading = false;
                            });
    


  }

}
